import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=582340ea&scoped=true&"
import script from "./Mark.vue?vue&type=script&lang=js&"
export * from "./Mark.vue?vue&type=script&lang=js&"
import style0 from "./Mark.vue?vue&type=style&index=0&id=582340ea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582340ea",
  null
  
)

export default component.exports